import * as type from '../types';

// GET MARKET PROCESSES
export const getMarketProcessesListRequest = () => ({
    type: type.GET_MARKET_PROCESSES_LIST_REQUEST
})

export const getMarketProcessesListSucceeded = data => ({
    type: type.GET_MARKET_PROCESSES_LIST_SUCCEEDED,
    payload: data
})

export const getMarketProcessesListFailed = () => ({
    type: type.GET_MARKET_PROCESSES_LIST_FAILED
})

// GET GENERAL OPERATIONS
export const getGeneralOperationsListRequest = (url, reqParams) => ({
    type: type.GET_GENERAL_OPERATIONS_LIST_REQUEST,
    payload: {
        url,
        reqParams
    }
})

export const getGeneralOperationsListSucceeded = list => ({
    type: type.GET_GENERAL_OPERATIONS_LIST_SUCCEEDED,
    payload: list
})

export const getGeneralOperationsListFailed = () => ({
    type: type.GET_GENERAL_OPERATIONS_LIST_FAILED
})

export const clearGeneralOperationsList = () => ({
    type: type.CLEAR_GENERAL_OPERATIONS_LIST
})

// GET AND SET CHART DATA
export const setChartTerm = chartTerm => ({
    type: type.SET_CHART_TERM,
    payload: chartTerm
})

export const getChartDataRequest = (year, month) => ({
    type: type.GET_CHART_DATA_REQUEST,
    payload: {
        year, 
        month
    }
})

export const getChartDataSucceeded = data => ({
    type: type.GET_CHART_DATA_SUCCEEDED,
    payload: data
})

export const getChartDataFailed = () => ({
    type: type.GET_CHART_DATA_FAILED
})

// GET ORGANIZED MARKET INFO
export const getOrganizedMarketInfoRequest = () => ({
    type: type.GET_ORGANIZED_MARKET_INFO_REQUEST,
})

export const getOrganizedMarketInfoSucceeded = data => ({
    type: type.GET_ORGANIZED_MARKET_INFO_SUCCEEDED,
    payload: data
})

export const getOrganizedMarketInfoFailed = () => ({
    type: type.GET_ORGANIZED_MARKET_INFO_FAILED
})

// GET SYSTEM MSG
export const getSystemMsgListRequest = reqParams => ({
    type: type.GET_SYSTEM_MSG_LIST_REQUEST,
    payload: reqParams
})

export const getSystemMsgListSucceeded = data => ({
    type: type.GET_SYSTEM_MSG_LIST_SUCCEEDED,
    payload: data
})

export const getSystemMsgListFailed = () => ({
    type: type.GET_SYSTEM_MSG_LIST_FAILED
})

// GET OBJECTIONS
export const getHomeObjectionsListRequest = () => ({
    type: type.GET_HOME_OBJECTIONS_LIST_REQUEST,
})

export const getHomeObjectionsListSucceeded = list => ({
    type: type.GET_HOME_OBJECTIONS_LIST_SUCCEEDED,
    payload: list
})

export const getHomeObjectionsListFailed = () => ({
    type: type.GET_HOME_OBJECTIONS_LIST_FAILED
})

// GET HOME BILATERAL
export const getHomeBilateralListRequest = organizationId => ({
    type: type.GET_HOME_BILATERAL_LIST_REQUEST,
    payload: organizationId
})

export const getHomeBilateralListSucceeded = list => ({
    type: type.GET_HOME_BILATERAL_LIST_SUCCEEDED,
    payload: list
})

export const getHomeBilateralListFailed = () => ({
    type: type.GET_HOME_BILATERAL_LIST_FAILED
})

// GET BILATERAL S AND B
export const getBilateralSAndBListRequest = organizationId => ({
    type: type.GET_BILATERAL_SANDB_LIST_REQUEST,
    payload: organizationId
})

export const getBilateralSAndBListSucceeded = list => ({
    type: type.GET_BILATERAL_SANDB_LIST_SUCCEEDED,
    payload: list
})

export const getBilateralSAndBListFailed = () => ({
    type: type.GET_BILATERAL_SANDB_LIST_FAILED
})

// GET HOME PRODUCTION DATA
export const getHomeProductionDataRequest = organizationId => ({
    type: type.GET_HOME_PRODUCTION_DATA_REQUEST,
    payload: organizationId
})

export const getHomeProductionDataSucceeded = list => ({
    type: type.GET_HOME_PRODUCTION_DATA_SUCCEEDED,
    payload: list
})

export const getHomeProductionDataFailed = () => ({
    type: type.GET_HOME_PRODUCTION_DATA_FAILED
})

// GET HOME ACTIVE CERTIFICATES
export const getHomeActiveCertificatesRequest = organizationId => ({
    type: type.GET_HOME_ACTIVE_CERTIFICATES_REQUEST,
    payload: organizationId
})

export const getHomeActiveCertificatesSucceeded = list => ({
    type: type.GET_HOME_ACTIVE_CERTIFICATES_SUCCEEDED,
    payload: list
})

export const getHomeActiveCertificatesFailed = () => ({
    type: type.GET_HOME_ACTIVE_CERTIFICATES_FAILED
})